import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=1361b2b4&scoped=true&"
var script = {}
import style0 from "./Full.vue?vue&type=style&index=0&id=1361b2b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361b2b4",
  null
  
)

export default component.exports